import { FiClock, FiMoreVertical } from "react-icons/fi";

const AdminSlotTableSkeleton = ({ rows = 6 }) => {
  const SkeletonCell = ({ className = "" }) => (
    <div className={`animate-pulse rounded-md bg-gray-200 ${className}`} />
  );
  return (
    <div className="overflow-x-auto">
      <table className="w-full table-fixed border border-gray-200 text-sm">
        <thead>
          <tr className="bg-brandAccentColor border-b-2">
            <th className="w-16 px-4 py-4" />
            <th className="w-60 px-4 py-4" />
            <th className="w-[30rem] px-4 py-4" />
            <th className="w-52 px-4 py-4" />
            <th className="w-20 px-4 py-4" />
          </tr>
        </thead>

        <tbody className="divide-y divide-gray-100">
          {Array.from({ length: rows }).map((_, idx) => (
            <tr key={idx} className="h-[88px]">
              {/* SL NO */}
              <td className="px-6">
                <SkeletonCell className="h-4 w-6" />
              </td>

              {/* TIME SLOT */}
              <td className="px-10">
                <div className="flex items-center gap-3">
                  <div className="size-10 rounded-lg bg-gray-300 animate-pulse flex items-center justify-center">
                    <FiClock className="text-gray-400" />
                  </div>
                  <div className="space-y-2">
                    <SkeletonCell className="h-4 w-32" />
                    <SkeletonCell className="h-3 w-20" />
                  </div>
                </div>
              </td>

              {/* ACTIVE DAYS */}
              <td className="px-6">
                <div className="grid grid-cols-7 gap-2">
                  {Array.from({ length: 7 }).map((_, d) => (
                    <SkeletonCell key={d} className="h-8 rounded-lg" />
                  ))}
                </div>
              </td>

              {/* STATUS */}
              <td className="px-6">
                <div className="flex items-center justify-center gap-2">
                  <SkeletonCell className="h-6 w-12 rounded-full" />
                  <SkeletonCell className="h-4 w-16" />
                </div>
              </td>

              {/* ACTION */}
              <td className="px-6 text-center">
                <FiMoreVertical className="text-gray-300 text-lg animate-pulse" />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default AdminSlotTableSkeleton